import React, { useState, SyntheticEvent } from 'react';

import { Button, Checkbox, WarningModalBody } from '@trqk/components';
import { locale, setInLocalStorage } from '@trqk/utils';

/**
 * Modal content to be shown when we detect that something in a user's environment is blocking our
 * network calls.
 */
export const ScriptBlockerWarning = ({
    input,
    remove,
}: ModalContentProps<{
    localStorageKey: string;
}>): JSX.Element => {
    const [checked, setChecked] = useState(false);
    const localStorageKey = input?.localStorageKey ?? null;

    const publicUrl = process.env.PUBLIC_URL;

    const appUrl =
        publicUrl.length > 0
            ? publicUrl
            : locale.enUS.SCRIPT_BLOCKER_WARNING.BODY.LINE_3.FALLBACK_URL;

    return (
        <WarningModalBody width={600} height={400}>
            <h5 className="text-quinary-700 mt-2">
                {locale.enUS.SCRIPT_BLOCKER_WARNING.TITLE}
            </h5>
            <div className="my-4">
                <div className="space-y-4 text-sm">
                    <p>{locale.enUS.SCRIPT_BLOCKER_WARNING.BODY.LINE_1}</p>
                    <p>{locale.enUS.SCRIPT_BLOCKER_WARNING.BODY.LINE_2}</p>
                    <p>
                        {locale.enUS.SCRIPT_BLOCKER_WARNING.BODY.LINE_3.PART_1}{' '}
                        <code>{appUrl}</code>{' '}
                        {locale.enUS.SCRIPT_BLOCKER_WARNING.BODY.LINE_3.PART_2}
                    </p>
                </div>
            </div>

            <div className="mt-6 flex justify-between items-center">
                <Checkbox
                    checked={checked}
                    color="quinary"
                    inputId="silence-script-blocker-checkbox"
                    label={locale.enUS.SCRIPT_BLOCKER_WARNING.SILENCE}
                    onChange={(e: SyntheticEvent): void => {
                        const target = e.target as HTMLInputElement;

                        if (target.checked) {
                            setChecked(true);
                        } else {
                            setChecked(false);
                        }
                    }}
                />
                <Button
                    color="danger-primary-light-bg"
                    autoWidth={true}
                    handleClick={() => {
                        if (localStorageKey !== null) {
                            setInLocalStorage<boolean>(
                                localStorageKey,
                                () => checked,
                            );
                        }

                        remove({
                            success: true,
                            canceled: false,
                        });
                    }}
                >
                    {locale.enUS.SCRIPT_BLOCKER_WARNING.CLOSE}
                </Button>
            </div>
        </WarningModalBody>
    );
};
